/** Zod validation schemas for Tags endpoints */

import { z } from 'zod'

export const listTagsQuerySchema = z.object({
  prefix: z.string().max(50).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50).optional(),
})

export const createTagSchema = z.object({
  name: z.string().min(1).max(50),
})
